var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSmallGreenPlus(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.321,
    height: 22.321,
    viewBox: "0 0 22.321 22.321",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .small-green-plus-b {\n                fill: none;\n                stroke: #fff;\n                stroke-width: 2px\n            }\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1212.679 -1275.51)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 11.161,
    cy: 11.161,
    r: 11.161,
    transform: "translate(1212.679 1275.51)"
  }), /*#__PURE__*/React.createElement("line", {
    y2: 10.146,
    className: "small-green-plus-b",
    transform: "translate(1223.839 1281.394)"
  }), /*#__PURE__*/React.createElement("line", {
    x2: 10.146,
    className: "small-green-plus-b",
    transform: "translate(1218.563 1286.67)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallGreenPlus);
export default __webpack_public_path__ + "static/media/small-green-plus.31ab7cdf.svg";
export { ForwardRef as ReactComponent };